const KEY = "landoo.recentlyViewed";
const MAX = 24;

export interface RecentItem {
  id: string;
  title: string;
  price: string | null;
  image: string | null;
  service: string | null;
  city: string | null;
  viewedAt: number;
}

function read(): RecentItem[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as unknown) : [];
    return Array.isArray(list)
      ? (list as RecentItem[]).filter((i) => i && typeof i.id === "string")
      : [];
  } catch {
    return [];
  }
}

function write(list: RecentItem[]) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
}

export function listRecentlyViewed(): RecentItem[] {
  return read().sort((a, b) => b.viewedAt - a.viewedAt);
}

export function recordView(item: Omit<RecentItem, "viewedAt">) {
  const list = read().filter((i) => i.id !== item.id);
  list.unshift({ ...item, viewedAt: Date.now() });
  write(list);
}

export function clearRecentlyViewed() {
  write([]);
}
